import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs, H3, Image, SVG } from "../../../AbstractElements";
import { Href, UserCards, Users } from "../../../Constant";
import { dynamicImage } from "../../../Service/DynamicImage";
import { USER_CARD_DATA } from "../../../Data/Users";
import SocialMediaIcons from "./SocialMediaIcons";
import UserCardsFooter from "./UserCardsFooter";

const UserCardContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={UserCards} parent={Users} title={UserCards} />
      <Container fluid>
      <Row className="user-cards-items">
        {USER_CARD_DATA.map((item) => (
          <Col xl="3" lg="4" xxl="3" md="6" sm="12" className="box-col-3" key={item.id}>
            <Card className="social-profile">
              <CardBody>
                <div className="social-img-wrap">
                  <div className="social-img">
                    <Image src={dynamicImage(`${item.avatar}`)} className="img-fluid" alt="user"/>
                  </div>
                  <div className="edit-icon">
                    <SVG iconId="profile-check" />
                  </div>
                </div>
                <div className="social-details">
                  <H3 className="mb-1">
                    <a href={Href}>{item.name}</a>
                  </H3>
                  <span className="f-light">{item.userProfile}</span>
                  <SocialMediaIcons />
                  <UserCardsFooter  item={item} />
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
    </>
  )
};

export default UserCardContainer;
